import { render, staticRenderFns } from "./chrelist.vue?vue&type=template&id=36e80919&"
import script from "./chrelist.vue?vue&type=script&lang=js&"
export * from "./chrelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports